<template>
  <!-- 专题列表 用于关联使用 -->
  <div class="table_dialog">
    <el-table
      class="table"
      v-loading="loading"
      ref="multipleTableRef"
      :data="tableData"
      max-height="450px"
      border
      :header-cell-style="{ background: '#f5f7fa' }"
      style="width: 100%; margin-top: 10px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <!-- <el-table-column
        fixed
        prop="id"
        label="id"
        width="55"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template #default="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="
              scope.row.oldId ? 'oldId为:' + scope.row.oldId : 'oldId为:空'
            "
            placement="top-start"
          >
            <span>{{ scope.row.id }}</span>
          </el-tooltip>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="name"
        label="专题名称"
        width="200"
        align="left"
        :show-overflow-tooltip="true"
        inputSearch="true"
      >
        <template #default="scope">
          <span :class="scope.row.name ? '' : 'gray'">{{
            scope.row.name ? scope.row.name : "未设置"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="remarks"
        label="备注"
        width="200"
        align="center"
        :show-overflow-tooltip="true"
      >
        <template #default="scope">
          <span v-if="scope.row.remarks == ''" class="gray">
            未设置
          </span>
          <span v-else>
           {{ scope.row.remarks }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width=""
        align="center"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
    </el-table>
  </div>
  <div class="choose_bom">
    <span style="margin-right: 10px" v-if="multipleSelection.length > 0"
      >已选择[
      <b class="select_red" style="font-size: 16px">{{
        multipleSelection.length
      }}</b>
      ]个专题</span
    >
    <span style="margin-right: 10px" v-else>请先选择专题</span>
    <div style="font-size: 16px; float: right">
      <el-button @click="closeDialog($event)" size="large">取消</el-button>
      <el-button size="large" type="primary" @click="clickTrue($event)"
        >确定</el-button
      >
    </div>
  </div>
</template>

<script>
import { getAllSpecialTopics } from "network/articleList.js";
import {
  reactive,
  onMounted,
  watch,
  toRefs,
  ref,
  toRaw,
  nextTick,
  defineProps,
} from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
export default {
  name: "ProjectRelevancy",
  props: { idsArray: Array, type: Number },
  components: {},
  emits: {
    "change-project": null,
    "close-dialog": null,
  },
  setup(props, { emit }) {
    const multipleTableRef = ref(null);
    const data = reactive({
      tableData: [],
      // 表格是否在加载中
      loading: true,
      multipleSelection: [], //选中行数据
      selectIds: [],
    });

    //初始化选中的行
    function changeSelRow(ids) {
      if (ids) {
        //1 先全部取消
        data.tableData.forEach((item) => {
          multipleTableRef.value.toggleRowSelection(item, false);
        });
      }
      // 赋值选中行数据
      data.multipleSelection = ids;
      // 2.再重新选中父组件传过来存在的数据
      data.tableData.forEach((item) => {
        ids.forEach((subItem) => {
          if (item.id === subItem) {
            multipleTableRef.value.toggleRowSelection(item, true);
          }
        });
      });
    }
    //挂载后调用函数获取项目数据
    onMounted(() => {
          data.selectIds = JSON.parse(JSON.stringify(props.idsArray));
          getAllSpecialList(); //获取专题列表
    });
    function getAllSpecialList() {
      getAllSpecialTopics(data.selectIds).then((result) => {
        if (result && result.code == 1) {
          data.loading = false;
          data.tableData = result.result;
          nextTick(() => {
            changeSelRow(data.selectIds);
          });
        } else {
          data.loading = false;
          ElMessage.error(result.messag);
        }
      });
    }
    // 表格多选行处理
    const handleSelectionChange = (row) => {
      data.multipleSelection = JSON.parse(JSON.stringify(row));
    };
    // 取消
    const closeDialog = (e) => {
      // lostFocus(e);
      // if (data.multipleSelection && data.multipleSelection.length > 0) {
      //   ElMessageBox.confirm("将取消当前选中专题", "取消", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   })
      //     .then(() => {
      //       data.multipleSelection = [];
      //       data.tableData.forEach((item) => {
      //         multipleTableRef.value.toggleRowSelection(item, false);
      //       });
      //       emit("close-dialog");
      //     })
      //     .catch(() => {});
      // } else {
        emit("close-dialog");
      // }
    };
    //确定选中
    const clickTrue = (e) => {
      lostFocus(e);
      if (data.multipleSelection.length == 0) {
        ElMessage.warning("请先选择专题");
      } else {
        // 新数组,用来装数据
        var newArr = [];
        toRaw(data.multipleSelection).map(function (sel, index) {
          var sevm = {};
          sevm["id"] = sel.id;
          sevm["typeName"] = "专题";
          sevm["type"] = JSON.parse(JSON.stringify(props.type)); //关联类型值 key
          sevm["name"] = sel.name;
          newArr[index] = sevm;
        });
        var ids = [];
        newArr.map((org) => {
          ids.push(org.id);
        });
        data.selectIds = ids;
              emit("change-project", newArr);
        emit("close-dialog");
      }
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      multipleTableRef,
      handleSelectionChange,
      closeDialog,
      clickTrue,
    };
  },
};
</script>

<style scoped>
.choose_bom {
  margin-top: 30px;
  line-height: 35px;
}
.select_red {
  color: red;
}
>>> .el-form-item--large .el-form-item__content {
  line-height: 23px !important;
}
</style>